import * as Actions from '../redux/actions/actions-consts';
import {
  setWebsiteCreatedCookie,
  trackPageview,
  trackEvent,
  trackErrorOnAction,
  trackDWH,
  trackToBunchBox,
  loadTrackingIframe,
  trackGtmEvent,
  TrackedSignupActionName,
  TrackingLabel,
} from '../modules/tracking';
import { langToLocale } from '../modules/helpers';
import { isGhostInspectorTest } from '../modules/cookies';
import { Dispatch, Middleware, MiddlewareAPI } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { AppState } from '../redux/reducers';
import { TRACKING_IFRAME_ENDPOINT } from '../modules/constants';
import isAction from './helpers';
import { getSelectedTrackingState } from '../redux/selectors';
import {
  ROUTER_PUSH_ACTION,
  SET_INDUSTRY,
  SET_PACKAGE,
  SET_PRODUCT,
  SET_SUBTYPE,
  SET_SIGNUP_WITH_PRODUCT_NAMING,
} from '../redux/actions/actions-consts';

export const SIGNUP_FLOW_NAMESPACE = 'signup-flow';
const FREE_SIGNUP_GOAL_PATHNAME = '/free-signup';

const nextTick = require('next-tick');

export interface TrackingOptions {
  tracked?: {
    action: TrackedSignupActionName;
    label: TrackingLabel;
  };
}

const trackingMiddleware: Middleware = (store: MiddlewareAPI<AppState>) => {
  return (next: Dispatch<AppState>) => {
    // tslint:disable-next-line no-any
    return (action: any) => {
      const state = store.getState();

      nextTick(() => {
        if (isGhostInspectorTest()) {
          console.log('is GhostInspector Test ..'); // eslint-disable-line no-console
        }

        if (isAction(action) && !isGhostInspectorTest()) {
          if (action.meta && action.meta.tracked) {
            action.error
              ? trackErrorOnAction(action.type, action.payload)
              : trackEvent(action.type, action.payload);
            // here we use the raw data as it is our data warehouse
            let trackingState = undefined;
            if (
              action.type === Actions.WEBSITE_CREATION_SUCCESS ||
              action.type === Actions.CHECKOUT_CONFIG_GENERATED
            ) {
              trackingState = getSelectedTrackingState(state);
            }
            trackDWH(action.meta.tracked.action, action.meta.tracked.label, {
              payload: action.payload,
              trackingState,
            });
          }

          if (action.type === ROUTER_PUSH_ACTION && action.payload) {
            const { lang } = state.options;
            trackToBunchBox('evaluate experiments', {
              attributes: {
                language: lang,
              },
            });
            const pathname = action.payload;
            trackGtmEvent('virtpath', {
              virtpath: window.location.pathname,
            });
            trackPageview(pathname);
          }

          if (action.type === SET_INDUSTRY && action.payload) {
            trackGtmEvent('Custom Dimensions', {
              industry: action.payload,
            });
          }

          if (action.type === SET_PRODUCT && action.payload) {
            trackGtmEvent('Custom Dimensions', {
              toolType: action.payload,
            });
          }

          if (action.type === SET_PACKAGE && action.payload) {
            trackGtmEvent('Custom Dimensions', {
              productType: action.payload,
            });
          }

          if (action.type === SET_SUBTYPE && action.payload) {
            trackGtmEvent('Custom Dimensions', {
              style: action.payload,
            });
          }

          if (action.type === SET_SIGNUP_WITH_PRODUCT_NAMING && action.payload) {
            const experiment = action.payload;
            trackToBunchBox('evaluate experiments', {
              attributes: {
                experiment,
              },
            });
          }

          if (
            action.type === Actions.WEBSITE_CREATION_SUCCESS ||
            action.type === Actions.CHECKOUT_CONFIG_GENERATED
          ) {
            const trackingState = getSelectedTrackingState(state);

            if (action.type === Actions.WEBSITE_CREATION_SUCCESS) {
              trackToBunchBox('track event goal', 'website_created_with_signup_flow');

              setWebsiteCreatedCookie('website_created_with_signup_flow');
              const locale = langToLocale(state.options.lang);
              loadTrackingIframe(TRACKING_IFRAME_ENDPOINT, locale);
              trackPageview(FREE_SIGNUP_GOAL_PATHNAME);

              trackEvent(`FINAL_${action.type}`, trackingState);
              trackGtmEvent('freeCreatorWebsiteCreated', {
                website: action.payload && action.payload.username,
              });
            }

            if (action.type === Actions.CHECKOUT_CONFIG_GENERATED) {
              trackEvent(`FINAL_${action.type}`, trackingState);
            }
          }
        }
      });

      // tslint:disable-next-line no-any
      next(action as ThunkAction<any, any, any>);
    };
  };
};

export default trackingMiddleware;
